export const RESOURCES = {
  gold: "Gold",
  silver: "Silver",
  tokens: "Token",
  counters: "Tank token",
  red_tokens: "Red Token",
  drawings: "Drawing",
  premium_akk: "Premium account",
  regular_cases: "Regular container",
  special_cases: "Special container",
  rare_cases: "Rare container",
  mythical_cases: "Mythical container",
  legendary_cases: "Legendary container",
};

export const TANKS = {
  2: {
    id: 2,
    name: "Об'єкт 490",
    transcription: "obj_490",
    type: "ht",
    land: "ua",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ukraine/obj_490.html",
    exchange: 5700,
  },
  3: {
    id: 3,
    name: "Білка",
    transcription: "obj_490_squirrel",
    bg: "obj_490_squirrel-bg",
    type: "camo",
    land: "ua",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ukraine/obj_490.html",
    exchange: 1500,
  },
  5: {
    id: 5,
    name: "PZ 5/4",
    transcription: "pz_5-4",
    type: "lt",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/pz_5-4.html",
    exchange: 4200,
  },
  6: {
    id: 6,
    name: "Т-20-22",
    transcription: "t_20_22",
    type: "lt",
    land: "inter",
    link: "https://lonja971.github.io/WomT_wiki/tanks/t-20-22.html",
    exchange: 5100,
  },
  7: {
    id: 7,
    name: "Sheridan",
    transcription: "sheridan",
    type: "lt",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/sheridan.html",
    exchange: 5400,
  },
  8: {
    id: 8,
    name: "БТ-СВ",
    transcription: "bt_sv",
    type: "lt",
    land: "ussr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ussr/bt-sv.html",
    exchange: 7000,
  },
  9: {
    id: 9,
    name: "AMX ELS bic",
    transcription: "amx_els_bic",
    type: "lt",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/amx_els_bis.html",
    exchange: 4800,
  },
  10: {
    id: 10,
    name: "ELS EVEN 90",
    transcription: "els_even_90",
    type: "lt",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/els_even_90.html",
    exchange: 5100,
  },
  11: {
    id: 11,
    name: "Progetto 46",
    transcription: "progetto_46",
    type: "lt",
    land: "it",
    link: "https://lonja971.github.io/WomT_wiki/tanks/italy/progetto_46.html",
    exchange: 5100,
  },
  12: {
    id: 12,
    name: "Т-34 Харків",
    transcription: "t_34_kharkiv",
    type: "lt",
    land: "ua",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ukraine/t34_kharkiv.html",
    exchange: 4800,
  },
  13: {
    id: 13,
    name: "Т-54",
    transcription: "t_54",
    type: "lt",
    land: "ua",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ukraine/t54.html",
    exchange: 5100,
  },
  14: {
    id: 14,
    name: "Kranwagn",
    transcription: "kranwagn",
    type: "ht",
    land: "sw",
    link: "https://lonja971.github.io/WomT_wiki/tanks/sweden/kranwagn.html",
    exchange: 5700,
  },
  15: {
    id: 15,
    name: "AMX M4 54",
    transcription: "amx_m4_54",
    type: "ht",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/amx_m4_54.html",
    exchange: 5400,
  },
  16: {
    id: 16,
    name: "Maus",
    transcription: "maus",
    type: "ht",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/maus.html",
    exchange: 5700,
  },
  17: {
    id: 17,
    name: "Tiger (P)",
    transcription: "tiger_p",
    type: "ht",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/tiger_p.html",
    exchange: 5100,
  },
  18: {
    id: 18,
    name: "Tiger Titan",
    transcription: "tiger_titan",
    type: "ht",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/tiger_titan.html",
    exchange: 5100,
  },
  19: {
    id: 19,
    name: "M5 Yoh",
    transcription: "m5_yoh",
    type: "ht",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/m5_yoh.html",
    exchange: 5700,
  },
  20: {
    id: 20,
    name: "Bisonte C45",
    transcription: "bisonte_c45",
    type: "ht",
    land: "it",
    link: "https://lonja971.github.io/WomT_wiki/tanks/italy/bisonte_c45.html",
    exchange: 5400,
  },
  21: {
    id: 21,
    name: "Type 5 Heavy",
    transcription: "type_5_heavy",
    type: "ht",
    land: "jp",
    link: "https://lonja971.github.io/WomT_wiki/tanks/japan/type_5_heavy.html",
    exchange: 5700,
  },
  22: {
    id: 22,
    name: "Т-64 БМ Оплот",
    transcription: "t_64_bm_oplot",
    type: "ht",
    land: "ua",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ukraine/t640plot.html",
    exchange: 5700,
  },
  23: {
    id: 23,
    name: "КВ-2",
    transcription: "kv_2",
    type: "ht",
    land: "ussr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ussr/kv-2.html",
    exchange: 4800,
  },
  24: {
    id: 24,
    name: "ИС-2 Варіант ||",
    transcription: "is_2_var2",
    type: "ht",
    land: "ussr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ussr/is-2_var_2.html",
    exchange: 5100,
  },
  25: {
    id: 25,
    name: "T-95",
    transcription: "t_95",
    type: "td",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/t-95.html",
    exchange: 5400,
  },
  26: {
    id: 26,
    name: "Grill 15",
    transcription: "grill_15",
    type: "td",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/grill_15.html",
    exchange: 5700,
  },
  27: {
    id: 27,
    name: "Віндікатор",
    transcription: "vindicator",
    type: "td",
    land: "inter",
    link: "https://lonja971.github.io/WomT_wiki/tanks/inter/vindicator.html",
    exchange: 5100,
  },
  28: {
    id: 28,
    name: "Minotauro",
    transcription: "minotauro",
    type: "td",
    land: "it",
    link: "https://lonja971.github.io/WomT_wiki/tanks/italy/minotauro.html",
    exchange: 5700,
  },
  29: {
    id: 29,
    name: "Bat-Chat 25t",
    transcription: "bat_chat_25t",
    type: "lt",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/bat-chat_25t.html",
    exchange: 4800,
  },
  30: {
    id: 30,
    name: "T-57 Heavy",
    transcription: "t_57_heavy",
    type: "ht",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/t57_heavy.html",
    exchange: 5400,
  },
  31: {
    id: 31,
    name: "Togg ||*",
    transcription: "togg_2",
    type: "ht",
    land: "br",
    link: "https://lonja971.github.io/WomT_wiki/tanks/britaine/togg_2.html",
    exchange: 4800,
  },
  32: {
    id: 32,
    name: "ИС-7",
    transcription: "is_7",
    type: "ht",
    land: "ussr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ussr/is-7.html",
    exchange: 5700,
  },
  33: {
    id: 33,
    name: "Дробар",
    transcription: "crusher",
    type: "ht",
    land: "inter",
    link: "https://lonja971.github.io/WomT_wiki/tanks/inter/krushitel.html",
    exchange: 5100,
  },
  34: {
    id: 34,
    name: "СУ-152",
    transcription: "sy_152",
    type: "td",
    land: "ussr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ussr/sy-152.html",
    exchange: 6000,
  },
  35: {
    id: 35,
    name: "S 35 CA",
    transcription: "s_35_ca",
    type: "td",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/s_35_ca.html",
    exchange: 4200,
  },
  36: {
    id: 36,
    name: "Cherchill GC",
    transcription: "cherchill_gc",
    type: "td",
    land: "br",
    link: "https://lonja971.github.io/WomT_wiki/tanks/britaine/churchill_gc.html",
    exchange: 4200,
  },
  37: {
    id: 37,
    name: "AMX 30 1-prot",
    transcription: "amx_30_1prot",
    type: "lt",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/amx_30-1.html",
    exchange: 5100,
  },
  38: {
    id: 38,
    name: "PZ B2",
    transcription: "pz_b2",
    type: "ht",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/pz_b2.html",
    exchange: 4800,
  },
  39: {
    id: 39,
    name: "WZ 111",
    transcription: "wz_111",
    type: "ht",
    land: "ch",
    link: "https://lonja971.github.io/WomT_wiki/tanks/china/wz_111.html",
    exchange: 4800,
  },
  40: {
    id: 40,
    name: "СУ-130 ПМ",
    transcription: "sy_130_pm",
    type: "td",
    land: "ussr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ussr/sy-130pm.html",
    exchange: 5100,
  },
  41: {
    id: 41,
    name: "Strv 103b",
    transcription: "strv_103b",
    type: "td",
    land: "sw",
    link: "https://lonja971.github.io/WomT_wiki/tanks/sweden/strv_103b.html",
    exchange: 5700,
  },
  42: {
    id: 42,
    name: "Turbo Räumpanzer",
    smallName: "Turbo Räump...",
    transcription: "turbo_raumpanzer",
    type: "ht",
    land: "inter",
    link: "https://lonja971.github.io/WomT_wiki/tanks/inter/turbo_raumpanzer.html",
    exchange: 5100,
  },
  43: {
    id: 43,
    name: "Шерідан Ракетний",
    transcription: "sheridan_rocket",
    type: "camo",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/sheridan.html",
    exchange: 1500,
  },
  44: {
    id: 44,
    name: "Мандарин",
    transcription: "els_even_90_tangerine",
    bg: "tangerine_bg2",
    type: "camo",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/els_even_90.html",
    exchange: 1500,
  },
  45: {
    id: 45,
    name: "Зимній снайпер",
    transcription: "t_34_kharkiv_winter",
    bg: "snow_bg",
    type: "camo",
    land: "ua",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ukraine/t34_kharkiv.html",
    exchange: 2000,
  },
  46: {
    id: 46,
    name: "Т-54 Патріот1",
    transcription: "t_54_patriot1",
    type: "camo",
    land: "ua",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ukraine/t54.html",
    exchange: 500,
  },
  47: {
    id: 47,
    name: "Т-54 Патріот2",
    transcription: "t_54_patriot2",
    type: "camo",
    land: "ua",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ukraine/t54.html",
    exchange: 500,
  },
  48: {
    id: 48,
    name: "AMX M4 54 Новорічний",
    transcription: "amx_m4_54_newyear",
    bg: "snow_bg",
    type: "camo",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/amx_m4_54.html",
    exchange: 2000,
  },
  49: {
    id: 49,
    name: "Легіонер",
    transcription: "maus_legionary",
    type: "camo",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/maus.html",
    exchange: 1500,
  },
  50: {
    id: 50,
    name: "Привид",
    transcription: "maus_ghost",
    type: "camo",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/maus.html",
    exchange: 2000,
  },
  51: {
    id: 51,
    name: "Золотий Тигр",
    transcription: "golden_tiger",
    type: "camo",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/white_tiger.html",
    exchange: 2000,
  },
  52: {
    id: 52,
    name: `Чорний Ліс`,
    transcription: "tiger_blackforest",
    type: "camo",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/white_tiger.html",
    exchange: 1500,
  },
  53: {
    id: 53,
    name: "Tiger (P) GT",
    transcription: "tiger_p_gt",
    type: "camo",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/tiger_p.html",
    exchange: 1500,
  },
  54: {
    id: 54,
    name: "Незламний",
    transcription: "t_95_unbreakable",
    type: "camo",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/t-95.html",
    exchange: 1500,
  },
  55: {
    id: 55,
    name: "Новорічний Рейдер",
    transcription: "grill_15_newyear_raider",
    bg: "snow_bg",
    type: "camo",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/grill_15.html",
    exchange: 2500,
  },
  56: {
    id: 56,
    name: `Темні янголи`,
    transcription: "vindicator_dark_angels",
    type: "camo",
    land: "inter",
    link: "https://lonja971.github.io/WomT_wiki/tanks/inter/vindicator.html",
    exchange: 1500,
  },
  57: {
    id: 57,
    name: `Імперський кулак`,
    transcription: "vindicator_imperial_fist",
    type: "camo",
    land: "inter",
    link: "https://lonja971.github.io/WomT_wiki/tanks/inter/vindicator.html",
    exchange: 1500,
  },
  58: {
    id: 58,
    name: "Minotauro Новорічний",
    transcription: "minotauro_newyear",
    bg: "snow_bg",
    type: "camo",
    land: "it",
    link: "https://lonja971.github.io/WomT_wiki/tanks/italy/minotauro.html",
    exchange: 1500,
  },
  59: {
    id: 59,
    name: `Waff. Auf E 100`,
    transcription: "waff_auf_e_100",
    type: "td",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/waf_auf_e100.html",
    exchange: 5700,
  },
  60: {
    id: 60,
    name: "Останній Ваффентрагер",
    transcription: "waff_auf_e_100_the_last",
    type: "camo",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/waf_auf_e100.html",
    exchange: 1500,
    bg: "waff_auf_e_100_the_last-bg",
  },
  61: {
    id: 61,
    name: "E 100",
    transcription: "e_100",
    type: "ht",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/e100.html",
    exchange: 5700,
  },
  62: {
    id: 62,
    name: "Втоплений Титан",
    transcription: "e_100_sinked",
    type: "camo",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/e100.html",
    bg: "e_100_sinked-bg",
    exchange: 1500,
  },
  63: {
    id: 63,
    name: "Char Futur 4",
    transcription: "char_futur_4",
    type: "lt",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/char_futur_4.html",
    exchange: 5700,
  },
  64: {
    id: 64,
    name: "Project Murat",
    transcription: "project_murat",
    type: "lt",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/project_murat.html",
    exchange: 5700,
  },
  65: {
    id: 65,
    name: "FCM 50t",
    transcription: "fcm_50t",
    type: "lt",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/fcm_50t.html",
    exchange: 4200,
  },
  66: {
    id: 66,
    name: "AMX CDC",
    transcription: "amx_cdc",
    type: "lt",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/amx_cdc.html",
    exchange: 4200,
  },
  67: {
    id: 67,
    name: "AMX 13 75",
    transcription: "amx_13_75",
    type: "lt",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/amx_13_57.html",
    exchange: 4200,
  },
  68: {
    id: 68,
    name: "Panhard EBR 105",
    transcription: "panhard_ebr_105",
    smallName: "Pan. EBR 105...",
    type: "lt",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/panhard_ebr_105.html",
    exchange: 5700,
  },
  69: {
    id: 69,
    name: "AMX 50b",
    transcription: "amx_50b",
    type: "ht",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/amx_50b.html",
    exchange: 5400,
  },
  70: {
    id: 70,
    name: "AMX 30b",
    transcription: "amx_30b",
    type: "ht",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/amx_30b.html",
    exchange: 4800,
  },
  71: {
    id: 71,
    name: "Lorraine 40t",
    transcription: "lorraine_40t",
    type: "ht",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/lorrain_40t.html",
    exchange: 6000,
  },
  72: {
    id: 72,
    name: "FOSH 155",
    transcription: "fosh_155",
    type: "td",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/fosh_155.html",
    exchange: 5400,
  },
  73: {
    id: 73,
    name: "Богач",
    transcription: "amx_50b_bogach",
    type: "camo",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/amx_50b.html",
    exchange: 1500,
  },
  74: {
    id: 74,
    name: "Сталевий Мисливець",
    transcription: "amx_m4_54_steel_hunter",
    type: "camo",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/amx_m4_54.html",
    exchange: 2000,
  },
  75: {
    id: 75,
    name: "Королівський",
    transcription: "fosh_155_king",
    type: "camo",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/fosh_155.html",
    exchange: 1000,
  },
  76: {
    id: 76,
    name: "Піщаний",
    transcription: "panhard_ebr_105_sand",
    type: "camo",
    land: "fr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/france/panhard_ebr_105.html",
    exchange: 1000,
  },
  77: {
    id: 77,
    name: "E 25",
    transcription: "e_25",
    type: "td",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/e_25.html",
    exchange: 2000,
  },
  78: {
    id: 78,
    name: "ТІТТ Розанова",
    transcription: "titt_rozanov",
    type: "lt",
    land: "ussr",
    link: "https://lonja971.github.io/WomT_wiki/tanks/ussr/titt_rozanov.html",
    exchange: 5100,
  },
  79: {
    id: 79,
    name: "Hori Type 3",
    transcription: "hori_type_3",
    type: "td",
    land: "jp",
    link: "https://lonja971.github.io/WomT_wiki/tanks/japan/hori_type_3.html",
    exchange: 5400,
  },
  80: {
    id: 80,
    name: "Type 59 Gold",
    transcription: "type_59_gold",
    type: "lt",
    land: "ch",
    link: "https://lonja971.github.io/WomT_wiki/tanks/china/type_59_gold.html",
    exchange: 5100,
  },
  81: {
    id: 81,
    name: "WZ 113",
    transcription: "wz_113",
    type: "ht",
    land: "ch",
    link: "https://lonja971.github.io/WomT_wiki/tanks/china/wz-113.html",
    exchange: 5400,
  },
  82: {
    id: 82,
    name: "WZ Пилаючий",
    smallName: "WZ Пилаюч...",
    transcription: "wz_pilauchii",
    type: "td",
    land: "ch",
    link: "https://lonja971.github.io/WomT_wiki/tanks/china/wz_pilauchiy.html",
    exchange: 4200,
  },
  83: {
    id: 83,
    name: "Type KV-2 光",
    transcription: "type_kv-2",
    type: "lt",
    land: "ch",
    link: "https://lonja971.github.io/WomT_wiki/tanks/china/type_kv2_light.html",
    exchange: 5100,
  },
  84: {
    id: 84,
    name: "Золотий Дракон",
    transcription: "type_5_heavy_golder_dragon",
    type: "camo",
    land: "jp",
    link: "https://lonja971.github.io/WomT_wiki/tanks/japan/type_5_heavy.html",
    exchange: 1500,
    bg: "type_5_heavy_golder_dragon-bg",
  },
  85: {
    id: 85,
    name: "Самурай",
    transcription: "hori_type_3_samurai",
    type: "camo",
    land: "jp",
    link: "https://lonja971.github.io/WomT_wiki/tanks/japan/hori_type_3.html",
    exchange: 1500,
    bg: "hori_type_3_samurai-bg",
  },
  86: {
    id: 86,
    name: "Дракон",
    transcription: "wz_111_dragon",
    type: "camo",
    land: "ch",
    link: "https://lonja971.github.io/WomT_wiki/tanks/china/wz_111.html",
    exchange: 1500,
  },
  87: {
    id: 87,
    name: "Мідний Воїн",
    transcription: "wz_113_copper_warrior",
    type: "camo",
    land: "ch",
    link: "https://lonja971.github.io/WomT_wiki/tanks/china/wz-113.html",
    exchange: 1500,
  },
  88: {
    id: 88,
    name: "BZ-176",
    transcription: "bz_176",
    type: "ht",
    land: "ch",
    link: "https://lonja971.github.io/WomT_wiki/tanks/china/bz-176.html",
    exchange: 5400,
  },
  89: {
    id: 89,
    name: "114 SP2",
    transcription: "114_sp2",
    type: "td",
    land: "ch",
    link: "https://lonja971.github.io/WomT_wiki/tanks/china/114_sp2.html",
    exchange: 5400,
  },
  90: {
    id: 90,
    name: "AE Phase 1",
    transcription: "ae_phase_1",
    type: "ht",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/ae_phase_1.html",
    exchange: 5400,
  },
  91: {
    id: 91,
    name: "AE Phase 1 Новорічний",
    transcription: "ae_phase_1_new_year",
    bg: "snow_bg",
    type: "camo",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/ae_phase_1.html",
    exchange: 1500,
  },
  92: {
    id: 92,
    name: "Т-20-22 Новорічний",
    bg: "snow_bg",
    transcription: "t_20_22_new_year",
    type: "camo",
    land: "inter",
    link: "https://lonja971.github.io/WomT_wiki/tanks/inter/t-20-22.html",
    exchange: 1500,
  },
  93: {
    id: 93,
    name: "Sherman Sanders",
    smallName: "Sherman San...",
    transcription: "sherman_sanders",
    type: "lt",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/sherman_sanders.html",
    exchange: 4500,
  },
  94: {
    id: 94,
    name: "T-49",
    transcription: "t_49",
    type: "lt",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/t-49.html",
    exchange: 5100,
  },
  95: {
    id: 95,
    name: "M6A2E1",
    transcription: "m6a2e1",
    type: "ht",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/m6a2e1.html",
    exchange: 5100,
  },
  96: {
    id: 96,
    name: "T-28 Defender",
    transcription: "t_28_defender",
    type: "td",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/t28_defender.html",
    exchange: 4500,
  },
  97: {
    id: 97,
    name: "Гордий",
    transcription: "m5_yoh_proud",
    type: "camo",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/m5_yoh.html",
    exchange: 1500,
  },
  98: {
    id: 98,
    name: "Клоун",
    transcription: "m5_yoh_clown",
    type: "camo",
    land: "usa",
    link: "https://lonja971.github.io/WomT_wiki/tanks/usa/m5_yoh.html",
    exchange: 1500,
  },
  99: {
    id: 99,
    name: "Jagd. E 100",
    transcription: "jagdpanzer_E_100",
    type: "td",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/jag-panzer_e100.html",
    exchange: 5400,
  },
  100: {
    id: 100,
    name: "Tortoise",
    transcription: "tortoise",
    type: "td",
    land: "br",
    link: "https://lonja971.github.io/WomT_wiki/tanks/britaine/tortoise.html",
    exchange: 4800,
  },
  101: {
    id: 101,
    name: "Мандарин",
    transcription: "e_25_tangerine",
    bg: "tangerine_bg2",
    type: "camo",
    land: "ge",
    link: "https://lonja971.github.io/WomT_wiki/tanks/germany/e_25.html",
    exchange: 1500,
  },
};

//---EXCHANGE---

export const EXCHANGE = {
  gold: {
    silver: {
      exchange: "silver",
      exchangeValue: "3500",
      getValue: "100",
    },
    counters: {
      exchange: "counters",
      exchangeValue: "10",
      getValue: "200",
    },
    premium_akk: {
      exchange: "premium_akk",
      exchangeValue: "5",
      getValue: "500",
    },
    drawings: {
      exchange: "drawings",
      exchangeValue: "1",
      getValue: "300",
    },
    tokens: {
      exchange: "tokens",
      exchangeValue: "1",
      getValue: "100",
    },
    red_tokens: {
      exchange: "red_tokens",
      exchangeValue: "1",
      getValue: "150",
    },
  },
  red_tokens: {
    tokens: {
      exchange: "tokens",
      exchangeValue: "2",
      getValue: "1",
    },
    gold: {
      exchange: "gold",
      exchangeValue: "250",
      getValue: "1",
    },
  }
};

//---COLLECTIONS---

const COLLECTIONS = {
  main_collection: "New Year's Collection",
  nationals_collection: "Collection of the Country",
  china_new_year: "Chinese New Year",
  roles_collection: "Role Collection",
};

//---CASES---

export const CASES = {
  main_cases: {
    name: "Main Container",
    transcription: "main_case",
    animation: "default",
    collection: COLLECTIONS.main_collection,
  },
  regular_cases: {
    name: "Regular container",
    transcription: "regular_case",
    animation: "regular_cases",
    collection: COLLECTIONS.main_collection,
  },
  special_cases: {
    name: "Special container",
    transcription: "special_case",
    animation: "special_cases",
    collection: COLLECTIONS.main_collection,
  },
  rare_cases: {
    name: "Rare container",
    transcription: "rare_case",
    animation: "rare_cases",
    collection: COLLECTIONS.main_collection,
  },
  mythical_cases: {
    name: "Mythical container",
    transcription: "mythical_case",
    animation: "mythical_cases",
    collection: COLLECTIONS.main_collection,
  },
  legendary_cases: {
    name: "Legendary container",
    transcription: "legendary_case",
    animation: "legendary_cases",
    collection: COLLECTIONS.main_collection,
  },
  //---КЕЙСИ-МАГАЗИНУ-КРЕСЛЕНЬ---

  new_year_mythical_tank1: {
    name: 'ТІТТ Розанова',
    transcription: "new_year_mythical_tank1",
    animation: "default",
    caseInfo: 'Guaranteed tank',
    award: 78,
  },
  new_year_mythical_tank2: {
    name: 'Project Murat',
    transcription: "new_year_mythical_tank2",
    animation: "default",
    caseInfo: 'Guaranteed tank',
    award: 64,
  },
  new_years_camo1: {
    name: 'AE Phase 1 New Year',
    transcription: "new_years_camo1",
    animation: "default",
    caseInfo: 'Guaranteed camouflage',
    award: 91,
  },
  new_years_camo2: {
    name: 'Embedded Titan E 100',
    transcription: "new_years_camo2",
    animation: "default",
    caseInfo: "Guaranteed camouflage",
    award: 62,
  },
  new_years_tank1: {
    name: "AE Phase 1",
    transcription: "new_years_tank1",
    animation: "default",
    caseInfo: "Guaranteed tank",
    award: 90,
  },
  new_years_tank2: {
    name: "E 100",
    transcription: "new_years_tank2",
    animation: "default",
    caseInfo: "Guaranteed tank",
    award: 61,
  },

  //---ІВЕНТНІ-КЕЙСИ---

  france_nation_cases: {
    name: "French Pies",
    transcription: "france_nation_cases",
    animation: "france_nation_cases",
    guarantor: 35,
    collection: COLLECTIONS.nationals_collection,
    guarantorAward: 63,
  },
  china_new_year_cases: {
    name: "Year of the Wood Snake",
    transcription: "china_new_year_cases",
    animation: "china_new_year_cases",
    guarantor: 35,
    collection: COLLECTIONS.china_new_year,
    guarantorAward: 88,
  },
  obj_490_cases: {
    name: "Squirrel №490",
    transcription: "obj_490_cases",
    animation: "obj_490_cases",
    guarantor: 35,
    guarantorAward: 2,
  },
  usa_nation_cases: {
    name: "American Pride",
    transcription: "usa_nation_cases",
    animation: "usa_nation_cases",
    guarantor: 35,
    collection: COLLECTIONS.nationals_collection,
    guarantorAward: 95,
  },
  td_support_cases: {
    name: "Support (TD)",
    transcription: "td_support_cases",
    animation: "td_support_cases",
    guarantor: 35,
    collection: COLLECTIONS.roles_collection,
    guarantorAward: 99,
  },
};

//---CASES-RESOURCES-INFO---

//---ДЛЯ-ПІДМАСИВІВ-TYPE-БУДЕ:
//-single-ЯКЩО-МОЖЕ-ВИПАСТИ-ОДИН-ЕЛЕМЕНТ
//-plural-ЯКЩО-МОЖЕ-ВИПАСТИ-БАГАТО-ЕЛЕМЕНТІВ

export const MAIN_CASE = [
  { 
    probability: 100,
    type: "single",
    items: [
      { type: "case", name: "regular_cases", probability: 42.5, amounts: [1] },
      { type: "case", name: "special_cases", probability: 35, amounts: [1] },
      { type: "case", name: "rare_cases", probability: 18, amounts: [1] },
      { type: "case", name: "mythical_cases", probability: 3, amounts: [1] },
      { type: "case", name: "legendary_cases", probability: 1.5, amounts: [1] },
    ]
  },
  { type: "gold", probability: 10, amounts: [ 100, 300, 400 ] },
  { type: "red_tokens", probability: 10, amounts: [ 1, 2 ] },
];

export const REGULAR_CASE = [
  { type: "silver", probability: 40, amounts: [1000, 1500], default: true },
  { type: "counters", probability: 40, amounts: [2, 3] },
  { type: "gold", probability: 20, amounts: [100] },
];

export const SPECIAL_CASE = [
  { type: "silver", probability: 30, amounts: [2000], default: true },
  { type: "counters", probability: 30, amounts: [5] },
  { type: "premium_akk", probability: 15, amounts: [1] },
  { type: "gold", probability: 15, amounts: [ 300, 500 ] },
  { 
    probability: 5,
    type: "single",
    items: [
      { type: "tank", id: 91, probability: 1, amounts: [1] },
      { type: "tank", id: 48, probability: 1, amounts: [1] },
    ]
  },
];

export const RARE_CASE = [
  { type: "silver", probability: 30, amounts: [ 3000, 5000 ], default: true },
  { type: "premium_akk", probability: 35, amounts: [1] },
  { type: "gold", probability: 30, amounts: [ 400, 600 ] },
  { type: "red_tokens", probability: 10, amounts: [ 2 ] },
  { type: "drawings", probability: 10, amounts: [1, 2] },
];

export const MYTHICAL_CASE = [
  { type: "premium_akk", probability: 35, amounts: [2] },
  { type: "gold", probability: 30, amounts: [1000, 2000] },
  { type: "drawings", probability: 30, amounts: [2, 3], default: true },
  { type: "red_tokens", probability: 20, amounts: [2, 4, 6] },
  { 
    probability: 25,
    type: "single",
    items: [
      { type: "tank", id: 7, probability: 1, amounts: [1] },
      { type: "tank", id: 36, probability: 1, amounts: [1] },
    ]
  },
];

export const LEGENDARY_CASE = [
  { type: "gold", probability: 30, amounts: [2000, 3000] },
  { type: "drawings", probability: 25, amounts: [3, 4], default: true, dafaultAmount: 3, },
  { type: "red_tokens", probability: 25, amounts: [4, 6, 8, 10] },
  { 
    probability: 50,
    type: "single",
    items: [
      { type: "tank", id: 90, probability: 1, amounts: [1] },
      { type: "tank", id: 15, probability: 1, amounts: [1] },
    ]
  },
];

//---КЕЙСИ-МАГАЗИНУ-КРЕСЛЕНЬ---

export const NEW_YEARS_MYTHICAL_TANK1 = [
  { type: "tank", id: 78, probability: 100, amounts: [1] },
];
export const NEW_YEARS_MYTHICAL_TANK2 = [
  { type: "tank", id: 64, probability: 100, amounts: [1] },
];
export const NEW_YEARS_CAMO_1 = [
  { type: "tank", id: 91, probability: 100, amounts: [1] },
];
export const NEW_YEARS_CAMO_2 = [
  { type: "tank", id: 62, probability: 100, amounts: [1] },
];
export const NEW_YEARS_TANK_1 = [
  { type: "tank", id: 90, probability: 100, amounts: [1] },
];
export const NEW_YEARS_TANK_2 = [
  { type: "tank", id: 61, probability: 100, amounts: [1] },
];


//---ІВЕНТОВІ-КЕЙСИ---

export const WAFF_CASE = [
  { type: "silver", probability: 35, amounts: [ 3000, 5000 ], default: true },
  { type: "premium_akk", probability: 30, amounts: [1, 2] },
  { type: "gold", probability: 20, amounts: [ 250, 250, 500 ] },
  //{ type: "red_tokens", probability: 10, amounts: [ 1, 2 ] },

  { type: "tank", id: 59, probability: 3, amounts: [1] },
  { type: "tank", id: 60, probability: 5, amounts: [1] },
];

export const FRANCE_NATION_CASE = [
  { type: "silver", probability: 35, amounts: [ 3000, 5000 ], default: true },
  { type: "premium_akk", probability: 30, amounts: [1, 2] },
  { type: "gold", probability: 20, amounts: [ 250, 250, 500 ] },
  { type: "tank", id: 63, probability: 2, amounts: [1] },
  { 
    probability: 2,
    type: "single",
    items: [
      { type: "tank", id: 65, probability: 1, amounts: [1] },
      { type: "tank", id: 66, probability: 1, amounts: [1] },
      { type: "tank", id: 37, probability: 1, amounts: [1] },
      { type: "tank", id: 67, probability: 1, amounts: [1] },
      { type: "tank", id: 68, probability: 1, amounts: [1] },
      { type: "tank", id: 29, probability: 1, amounts: [1] },
      { type: "tank",  id: 9, probability: 1, amounts: [1] },
      { type: "tank", id: 10, probability: 1, amounts: [1] },
      { type: "tank", id: 69, probability: 1, amounts: [1] },
      { type: "tank", id: 70, probability: 1, amounts: [1] },
      { type: "tank", id: 15, probability: 1, amounts: [1] },
      { type: "tank", id: 71, probability: 1, amounts: [1] },
      { type: "tank", id: 72, probability: 1, amounts: [1] },
      { type: "tank", id: 35, probability: 1, amounts: [1] },
    ]
  },
  { 
    probability: 5,
    type: "single",
    items: [

      { type: "tank", id: 73, probability: 1, amounts: [1] },
      { type: "tank", id: 74, probability: 1, amounts: [1] },
      { type: "tank", id: 75, probability: 1, amounts: [1] },
      { type: "tank", id: 76, probability: 1, amounts: [1] }
    ]
  },
];

export const CHINA_NEW_YEAR_CASE = [
  { type: "silver", probability: 35, amounts: [ 3000, 5000 ], default: true },
  { type: "premium_akk", probability: 30, amounts: [1, 2] },
  { type: "gold", probability: 15, amounts: [ 250, 250, 500 ] },
  { 
    probability: 3,
    type: "single",
    items: [
      { type: "tank", id: 83, probability: 1, amounts: [1] },
      { type: "tank", id: 88, probability: 1, amounts: [1] },
      { type: "tank", id: 89, probability: 1, amounts: [1] },
    ]
  },
];

export const OBJ_490_CASE = [
  { type: "silver", probability: 35, amounts: [ 3000, 5000 ], default: true },
  { type: "premium_akk", probability: 30, amounts: [1, 2] },
  { type: "gold", probability: 20, amounts: [ 250, 250, 500 ] },

  { type: "tank", id: 2, probability: 3, amounts: [1] },
  { type: "tank", id: 3, probability: 5, amounts: [1] },
];

export const USA_NATION_CASE = [
  { type: "silver", probability: 35, amounts: [ 3000, 5000 ], default: true },
  { type: "premium_akk", probability: 30, amounts: [1, 2] },
  { type: "gold", probability: 20, amounts: [ 250, 250, 500 ] },
  { 
    probability: 2,
    type: "single",
    items: [
      { type: "tank", id: 93, probability: 1, amounts: [1] },
      { type: "tank", id: 7, probability: 1, amounts: [1] },
      { type: "tank", id: 94, probability: 1, amounts: [1] },
      { type: "tank", id: 95, probability: 1, amounts: [1] },
      { type: "tank", id: 30, probability: 1, amounts: [1] },
      { type: "tank", id: 19, probability: 1, amounts: [1] },
      { type: "tank", id: 96, probability: 1, amounts: [1] },
      { type: "tank", id: 25, probability: 1, amounts: [1] },
    ]
  },
  { 
    probability: 4.8,
    type: "single",
    items: [
      { type: "tank", id: 54, probability: 1, amounts: [1] },
      { type: "tank", id: 97, probability: 1, amounts: [1] },
      { type: "tank", id: 98, probability: 1, amounts: [1] },
    ]
  },
];

export const TD_SUPPORT_CASE = [
  { type: "silver", probability: 35, amounts: [ 3000, 5000 ], default: true },
  { type: "premium_akk", probability: 30, amounts: [1, 2] },
  { type: "gold", probability: 20, amounts: [ 250, 250, 500 ] },
  { 
    probability: 3,
    type: "single",
    items: [
      { type: "tank", id: 89, probability: 1, amounts: [1] },
      { type: "tank", id: 25, probability: 1, amounts: [1] },
      { type: "tank", id: 100, probability: 1, amounts: [1] },
      { type: "tank", id: 72, probability: 1, amounts: [1] },
      { type: "tank", id: 34, probability: 1, amounts: [1] },
    ]
  },
];